import PlusIcon from '@rsuite/icons/Plus';
import { ContentHeader } from '../../../../components/ContentHeader';
import DuvidasButton from '../../../../components/DuvidasButton';
import { CustomButton } from '../../../../components/CustomButton';
import { FaHandshake } from 'react-icons/fa';

export function Header({ onOpenAddModal = () => {} }) {
  return (
    <ContentHeader
      title="Fidelidade"
      subtitle="Gerencie as fidelidades da sua empresa"
      icon={FaHandshake}
      thirdComponent={
        <>
          <DuvidasButton tela="loyalty" />
          <CustomButton appearance="primary" onClick={onOpenAddModal}>
            <PlusIcon style={{ marginRight: 6 }} />
            Adicionar Fidelidade
          </CustomButton>
        </>
      }
    />
  );
}
